import { Box, BoxProps, ColorOptions, ModBox } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { NewVerticalStepIndicator } from '../../../components/NewVerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { getValueFromLOVDescription, LOV_CODES, zoomOutIfRequire } from '../../../utils'
import { EntityOnboardingForm } from '../OnboardEntity/EntityOnboardingForm'
import { EntityOnboardingHeader } from '../OnboardEntity/EntityOnboardingHeader'
import { FullScreenLoader } from '../OnboardEntity/comps/FullScreenLoader'

const CheckerDetails = () => {
  const { claimEntityTaskAsync, loadInitials } = useStores((store) => ({
    claimEntityTaskAsync: store.entityOnboarding.claimEntityTaskAsync,
    loadInitials: store.entityOnboarding.loadInitials,
  }))

  const [currentStep, setCurrentStep] = useState(1)
  const [lazyClaimEntityTaskAsync, claimEntityTaskAsyncHandler] = useLazyApiData(claimEntityTaskAsync)
  const [lazyLoadInitials, loadInitialHandler] = useLazyApiData(loadInitials)

  useEffect(() => {
    entityDetails?.requestType !== 'BULK_TERMINAL_ADD' && lazyLoadInitials()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onStepPressed = useCallback((pressedStep: any) => {
    setCurrentStep(pressedStep)
  }, [])

  const routes: any = useRoute()
  const navigation = useNavigation()
  const { width } = useWindowDimensions()
  const savedData = JSON.parse(localStorage.getItem('queryParams'))
  const entityDetails = JSON.parse(JSON.stringify(routes?.params?.item ?? savedData?.item))
  const USER_TYPE = routes?.params?.type ?? savedData?.type

  const nativeID = `globalQueue_${USER_TYPE}`
  useEffect(() => {
    zoomOutIfRequire(nativeID)
  }, [])

  useEffect(() => {
    routes?.params && localStorage.setItem('queryParams', JSON.stringify(routes?.params))
  }, [routes?.params])

  const onClaimPressed = () => {
    console.log('onCliampRSSED', navigation)
    lazyClaimEntityTaskAsync(entityDetails?.taskInstanceId)
  }

  const getHeaderTitle = useCallback(() => {
    if (entityDetails?.requestType === 'BULK_TERMINAL_ADD') {
      return 'Terminal Details'
    } else if (USER_TYPE === 'checker1Queue') {
      return 'Checker1 Details'
    } else if (USER_TYPE === 'checker2Queue') {
      return 'Checker2 Details'
    } else if (USER_TYPE === 'riskCheckerQueue') {
      return 'RiskChecker Details'
    } else if (USER_TYPE === 'riskMakerQueue') {
      return 'RiskMaker Details'
    }
  }, [])

  useEffect(() => {
    if (claimEntityTaskAsyncHandler?.state === 'fulfilled') {
      navigation.reset({
        index: 0,
        routes: [{ name: USER_TYPE }],
      })
    }
  }, [claimEntityTaskAsyncHandler])

  const onBackPress = useCallback(() => {
    navigation.reset({
      index: 0,
      routes: [{ name: USER_TYPE }],
    })
  }, [USER_TYPE, navigation])

  const navigationState = navigation.getState()
  const verticalIndicatorSteps = modifiedMapperMetadata(entityDetails, USER_TYPE, loadInitialHandler?.data?.lovData)

  return (
    <Box h="100%" w="100%" overflow={'hidden'} padding={5}>
      <Container
        {...styles.container}
        isLoading={
          entityDetails?.requestType !== 'BULK_TERMINAL_ADD' &&
          (loadInitialHandler?.state === 'pending' || !loadInitialHandler?.state || !loadInitialHandler?.data)
        }
        onRetry={lazyLoadInitials}
        nativeID={nativeID}
        errorMessage={loadInitialHandler?.data?.message}>
        <EntityOnboardingHeader
          title={entityDetails?.businessDisplayName}
          applicationId={entityDetails?.applicationId}
          applicationStatus={entityDetails?.applicationStatus}
          businessChannel={entityDetails?.businessChannel}
          entityId={entityDetails?.entityIdentificationNumber}
          requestType={entityDetails?.requestType}
          onboardingChannel={entityDetails?.onboardingChannel}
          showBackButton={navigation.canGoBack() || navigationState.index > 0}
          onBackPress={onBackPress}
        />
        <ModBox show={entityDetails?.requestType !== 'BULK_TERMINAL_ADD'} {...styles.innerContainer}>
          <Box w={220}>
            <NewVerticalStepIndicator
              currentStep={currentStep}
              submitState={''}
              formValidationStatus={verticalIndicatorSteps.map(() => true)}
              steps={verticalIndicatorSteps}
              totalFilledStep={verticalIndicatorSteps.length}
              onStepPressed={onStepPressed}
              type="READ_ONLY"
            />
          </Box>
          <Box flex={1}>
            <EntityOnboardingForm
              currentStep={currentStep}
              onStepPressed={onStepPressed}
              initialValues={entityDetails}
              onSubmit={undefined}
              isEditable={false}
              fromChekerQueue={true}
              setIsCurrentFormValid={() => {}}
              userType={USER_TYPE}
            />
          </Box>
        </ModBox>
        <ModBox show={entityDetails?.requestType === 'BULK_TERMINAL_ADD'} flex={1}>
          <NewTable
            data={entityDetails?.terminals ?? []}
            rowHeight={48}
            headerHeight={64}
            height={'100%'}
            customWidthFunc={getCustomColumnWidth}
            tableWidth={width > 1200 ? width - 290 : width}
            headerRowKeys={terminalListHeaderTitles}
            onRowClick={undefined}
          />
        </ModBox>
        <Box
          flexDirection="row"
          padding={24}
          borderTopColor={'BORDER_COLOR'}
          borderTopWidth={1}
          justifyContent={'flex-end'}>
          <ButtonNew type={'primaryIconSmall'} width={240} title={'Claim'} icon="ADD" onPress={onClaimPressed} />
        </Box>
        <FullScreenLoader show={claimEntityTaskAsyncHandler.state === 'pending'} />
      </Container>
    </Box>
  )
}

export default CheckerDetails

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  innerContainer: {
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
}

const ENTITY_ONBOARDING_STEPS = [
  'Select Parent',
  'Business Contact',
  'Authorised Signatory',
  'Business Details',
  'Other Business Details',
  'Bank Details',
  'Document Upload',
  'Fee/Package Details',
  'Kyc approval data',
  'Risk Settings',
]

const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    referenceId: 100,
    nickName: 100,
    username: 100,
    programIdentifier: 100,
    terminalType: 100,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const terminalListHeaderTitles = {
  referenceId: 'Reference Id',
  nickName: 'Nick Name',
  username: 'User Name',
  programIdentifier: 'Program Identifier',
  terminalType: 'TerminalType',
}

const modifiedMapperMetadata = (initialValue, usertype, lovData) => {
  switch (usertype) {
    case 'checker2MyQueue':
      if (
        getValueFromLOVDescription(lovData, initialValue?.businessChannel, 'BusinessChannel') !== LOV_CODES.ONLINE &&
        initialValue.requestType === 'NEW_PROFILE'
      ) {
        return ENTITY_ONBOARDING_STEPS
      }
      break
  }
  if (
    ['riskCheckerQueue', 'riskMakerQueue'].includes(usertype) &&
    ['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(initialValue.requestType)
  ) {
    return [...ENTITY_ONBOARDING_STEPS, 'Interaction History']
  }

  return ENTITY_ONBOARDING_STEPS.slice(0, -1)
}
